// enrolledStudentsActionCreators.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getEnrolledStudentsService } from "../../../../../utils/services/enrolledStudents/enrolledStudentService";

export const fetchEnrolledStudents = createAsyncThunk(
  "/enrolledStudents/fetch",
  async ({ pageNo, pageLength, studentName, courseId, BatchIdDropdown, assessStatus, studentId }) => {
    console.log("pageNo pageNo", pageNo, pageLength, studentName, courseId, BatchIdDropdown, assessStatus, studentId);
    try {
      const response = await getEnrolledStudentsService({ pageNo, pageLength, studentName, courseId, BatchIdDropdown, assessStatus, studentId });
      console.log(response, "heheh")
      return response;
    } catch (error) {
      throw error;
    }
  }
);
